import App from "@frog/source/models/App.js"
import { DefeatAllUnitsOfAffiliation, HealPlayerPartyScript, Dialogue, MoveUnit, MoveEncounterScript, EscapeScript, SpawnUnitsScript } from "@frog/source/data/plotscripts.js"
import Audiomix from "@frog/source/juice/Audiomix.js"
import Navigation from "@frog/source/models/admin/Navigation.js"
import Dungeon from "@frog/source/data/games/dungeon/dungeon.js"

const dungeon = new Dungeon(
    {
        "partyPicks": ["daggerlich","swordskull","splitbone","speardead","daggercloak","gunner","axeknight"],
        "enemyJobs": "hammer,sword,spear,gun,dagger,bow",
    }
)
const groundColor = {}
groundColor.R = 20
groundColor.G = 70
groundColor.B = 10

export default {
    "slug": "distance",
    "hasPreparePhase": false,
    "startingEncounter": "1",

    "stage": {
        "image": dungeon.generateEnvironmentArt(groundColor),
        "world": dungeon.generateWorld(),
        "units": dungeon.generateUnits(),
        "conditions": [
            {
                "type": "turn:0:start",
                "events": [
                    // Plotscripts.SpawnPlayerPartyScript(),
                    {"func": () => Audiomix.trigger("Hell:Music:1")},
                    {
                        "type": "chapter start",
                        "data": [
                            "Chapter 4",
                            "DISTANCE",
                            "Melee can't counterattack Range",
                            "Range can't counterattack Melee"
                        ]
                    },
                ]
            },
            {
                "type": "condition",
                "condition": (stage) => {
                    return DefeatAllUnitsOfAffiliation({
                        "stage": stage,
                        "affiliation": "good",
                    })
                },
                "events": [
                    {"type": "chapter failure"},
                    {"func": () => Navigation.go("/games/dungeon")},
                    {"func": () => window.location.reload()},
                ]
            },
            {
                "type": "condition",
                "condition": (stage) => {
                    return DefeatAllUnitsOfAffiliation({
                        "stage": stage,
                        "affiliation": "bad",
                        "encounterKey": 1,
                    })
                },
                "events": [
                    HealPlayerPartyScript({"percent": 0.25}),
                    MoveEncounterScript({"nextEncounterKey": 2}),
                ]
            },
            {
                "type": "condition",
                "condition": (stage) => {
                    return DefeatAllUnitsOfAffiliation({
                        "stage": stage,
                        "affiliation": "bad",
                        "encounterKey": 2,
                    })
                },
                "events": [
                    HealPlayerPartyScript({"percent": 0.25}),
                    MoveEncounterScript({"nextEncounterKey": 3}),
                ]
            },
            {
                "type": "condition",
                "condition": (stage) => {
                    return DefeatAllUnitsOfAffiliation({
                        "stage": stage,
                        "affiliation": "bad",
                        "encounterKey": 3,
                    })
                },
                "events": [
                    MoveEncounterScript({"nextEncounterKey": 4}),
                    HealPlayerPartyScript({"percent": 0.25}),
                ]
            },
            {
                "type": "condition",
                "condition": (stage) => {
                    return DefeatAllUnitsOfAffiliation({
                        "stage": stage,
                        "affiliation": "bad",
                        "encounterKey": 4,
                    })
                },
                "events": [
                    MoveEncounterScript({"nextEncounterKey": 5}),
                    HealPlayerPartyScript({"percent": 0.25}),
                ]
            },
            {
                "type": "condition",
                "condition": (stage) => {
                    return DefeatAllUnitsOfAffiliation({
                        "stage": stage,
                        "affiliation": "bad",
                        "encounterKey": 5,
                    })
                },
                "events": [
                    MoveEncounterScript({"nextEncounterKey": 6}),
                    HealPlayerPartyScript({"percent": 0.25}),
                ]
            },
            {
                "type": "condition",
                "condition": (stage) => {
                    return DefeatAllUnitsOfAffiliation({
                        "stage": stage,
                        "affiliation": "bad",
                        "encounterKey": 6,
                    })
                },
                "events": [
                    {"func": () => Audiomix.trigger("Hell:Music:Victory")},
                    {"type": "chapter success"},
                    {"func": () => Navigation.go("/games/dungeon/chapters/speed")},
                ]
            },
        ]
    },
}
